<template>
  <div>
    <div class="tech">
      <div class="title">
        tools <br />
        & <br />
        technologies
      </div>
      <div>
        <a class="opts" href="#a">
          <i class="material-icons-outlined scroll swing">mouse</i>
          <br />
          <span class="swing">scroll down</span>
        </a>
      </div>
    </div>
    <div id="a"></div>
  </div>
</template>

<script>
export default {};
</script>
<style scoped>
.tech {
  margin-top: 2px;
  background-image: url("../../assets/vectors/0058.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  height: 100vh;
  background-attachment: scroll;
}
.title {
  font-size: 70px;
  text-align: center;
  font-weight: 600;
  padding-top: 25vh;
  color: white;
  text-transform: capitalize;
}
@media only screen and (max-width: 601px) {
  .title {
    font-size: 50px;
    text-align: center;
    padding-top: 20vh;
    font-weight: 600;
    color: white;
    text-transform: capitalize;
  }
  .opts {
    margin-top: 70px;
  }
}
@media only screen and (max-width: 601px) {
  .my {
    margin-top: 30px;
    margin-bottom: 30px;
  }
}
@-webkit-keyframes swinging {
  0% {
    /* -webkit-transform: (8deg); */
    -webkit-transform: translateY(10px);
  }
  50% {
    /* -webkit-transform: rotate(-4deg); */
    -webkit-transform: translateY(0px);
  }
  100% {
    /* -webkit-transform: rotate(8deg); */
    -webkit-transform: translateY(10px);
  }
}

@keyframes swinging {
  0% {
    /* -webkit-transform: (8deg); */
    -webkit-transform: translateY(10px);
  }
  50% {
    /* -webkit-transform: rotate(-4deg); */
    -webkit-transform: translateY(0px);
  }
  100% {
    /* -webkit-transform: rotate(8deg); */
    -webkit-transform: translateY(10px);
  }
}

.swing {
  -webkit-transform-origin: 50% 0;
  transform-origin: 50% 0;
  -webkit-animation: swinging 3.5s ease-in-out forwards infinite;
  animation: swinging 3.5s ease-in-out forwards infinite;
}
.scroll {
  color: white;
  padding: 14px;
  font-size: 26px;
}
span {
  writing-mode: vertical-rl;
  text-orientation: mixed;
  color: white;
  padding-left: 15px;
  font-size: 16px;
}
</style>
